import { ConnectionItem, Flex, Image, Text } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";
import { connectByPath } from "../../../data-sources";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

import { usePlatformConnectorProperties } from "../../queries";
import { authStartPath, useConnectionFlowsConfig } from "../../config";
import { COMMON_MESSAGES } from "../../common-messages";
import { ConnectionsList } from "../../common/connections";
import { OAuthErrorBanner } from "../../common/oauth-error-banner";
import { MESSAGES } from "../../messages";

const CONNECTOR_SLUG = "quickbooks";

export const QuickbooksConnect = ({ onInitiateConnection }: { onInitiateConnection?: () => void }) => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { connectorsApiUrl, defaultCallbackPath } = useConnectionFlowsConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(
    customerDomain,
    CONNECTOR_SLUG,
    defaultCallbackPath,
    connectorsApiUrl
  );
  const [connectionInProgress, setConnectionInProgress] = useState(false);

  return (
    <Flex direction="column" gap="8">
      <Flex direction="column" gap="8" align="flex-start" justify="space-between">
        <OAuthErrorBanner connectorSlug={CONNECTOR_SLUG} />
        <Text>{intl.formatMessage(MESSAGES.accountingPlatformDataUsage)}</Text>
        <ConnectionsList
          connectorProperties={connectorProperties}
          connectForm={
            <ConnectionItem
              logo={
                connectorProperties.connectionLogoSrc ? <Image src={connectorProperties.connectionLogoSrc} /> : null
              }
              label={connectorProperties.name}
              loading={connectionInProgress}
              actions={[
                {
                  content: intl.formatMessage(COMMON_MESSAGES.connectAccount),
                  variant: "Tertiary",
                  onAction: () => {
                    onInitiateConnection?.();
                    setConnectionInProgress(true);
                    connectByPath(authStartPath(customerDomain, CONNECTOR_SLUG, defaultCallbackPath));
                  },
                },
              ]}
            />
          }
        />
      </Flex>
    </Flex>
  );
};
